import dayjs from 'dayjs';

export const formatTaskDateTime = (value: string | null | undefined) => {
  return value ? dayjs(value).format('MMM D, YYYY HH:mm:ss') : '—';
};

export const formatTaskDuration = (seconds: number | null) => {
  if (seconds === null) {
    return '—';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours) {
    return `${hours}h ${minutes}m`;
  }
  if (minutes) {
    return `${minutes}m ${remainingSeconds}s`;
  }
  return `${remainingSeconds}s`;
};
